<template>
  <div
    class="guide"
    :class="[size ? 'guide-' + size : '', { 'not-subscribe': notSubscribe }]"
  >
    <div class="guide__tags">
      <Tag text="REPORT" background="brown" link="/reports" />
    </div>
    <div v-if="date" class="guide__date">
      <Date :text="date" :author="author" />
    </div>
    <div class="guide-bottom">
      <div v-if="download" class="guide__download">
        <Download :file="download" />
      </div>
    </div>
    <div class="guide__title">
      <nuxt-link :to="link" class="guide__title-link">{{ title }}</nuxt-link>
    </div>
    <div v-if="desc" class="guide__desc">{{ desc }}</div>
    <nuxt-link :to="link" class="guide__arrow-link">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11.911"
        height="9"
        viewBox="0 0 11.911 9"
      >
        <path
          id="Arrow"
          d="M17.793,131.582h0l-4.071-4.071a.407.407,0,1,0-.574.574l3.375,3.379H6.407a.407.407,0,0,0,0,.814H16.523l-3.375,3.375a.407.407,0,1,0,.574.574l4.071-4.071A.407.407,0,0,0,17.793,131.582Z"
          transform="translate(-6 -127.369)"
          fill="#003d6a"
        />
      </svg>
    </nuxt-link>
  </div>
</template>

<script>
// import { mapState } from "vuex";
// import config from "../../nuxt.config";
export default {
  name: "Guide",
  components: {
    Tag: () => import("../elements/Tag"),
    Date: () => import("../elements/Date"),
  },
  props: {
    tags: {
      type: [Array, String],
      default: null,
    },
    reports: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    desc: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
    author: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: "/",
    },
    image: {
      type: String,
      default: null,
    },
    download: {
      type: String,
      default: null,
    },
    bigImage: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: null,
    },
    productAccess: {
      type: [Array, Number],
      default: null,
    },
    updates: {
      type: Boolean,
      default: false,
    },
    isPremiumReport: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    notSubscribe: false,
  }),
  computed: {},
  watch: {},
  mounted() {},
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.guide {
  height: 100%;
  position: relative;
  background: $lighterBrightBlue;
  padding: 2rem 2.4rem;

  @include below($md) {
    margin-bottom: 2.4rem;
    height: auto;
    width: 100%;
  }

  &.border {
    .guide__title {
      border-top: 1px solid $border;
      padding-top: 1rem;
    }
  }

  &__tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid $corporateBlue;
    margin-bottom: 1.2rem;

    &-more {
      margin-left: 1rem;
      font-weight: 600;
    }
  }

  &__report {
    display: flex;
    margin-bottom: 1.2rem;
  }

  &__title {
    margin-bottom: 1rem;

    &-link {
      color: $text_gray;
      font-size: 1.8rem;
      line-height: 2.4rem;
      font-weight: 700;
      text-decoration: none;
      transition: 0.3s ease-out;

      &:hover {
        color: $brightGreen;
      }

      @include below($md) {
        font-size: 2rem;
        line-height: 2.4rem;
      }
    }
  }
  &__desc {
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: $text_gray;
    margin-bottom: 1rem;
    padding-right: 1rem;
  }
  &__image {
    width: 100%;
    height: 27rem;
    display: block;
    margin-bottom: 1.6rem;
    transition: 0.3s ease-out;

    &:hover {
      opacity: 0.7;
    }

    &--big {
      height: 34rem;
    }

    @include below($md) {
      height: 20rem;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-bottom {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  mark {
    background-color: $lighterBrightBlue;
  }

  &__updates {
    .guide__title-link {
      font-size: 1.4rem !important;
      line-height: 1.65rem;
    }
  }
}
</style>
